import moment from 'moment';
import _clone from 'lodash/clone';

export const MENTION_REGEX = '@\\[(.*)\\]\\((.*)\\)';

export const userSubscribedToComments = (user, users) => {
  return users.some(currentUser => user === currentUser.id);
};

export const getInitials = (firstName, lastName) => {
  const initials = `${firstName.charAt(0)}${lastName.charAt(0)}`;
  return initials.toUpperCase;
};
export const isMention = searchText => {
  const regex = RegExp(MENTION_REGEX, 'gm');
  return regex.test(searchText);
};
export const formatUsers = users => {
  return users.map(user => {
    const firstName = user.firstName.replace(' ', '');
    const lastName = user.lastName.replace(' ', '');
    const username = `@${firstName.toLowerCase()}${lastName}`;
    return {
      id: user.id,
      firstName: user.firstName,
      lastName: user.lastName,
      display: username
    };
  });
};
//export const formatComment=
export const getUserById = (userId, users) => {
  const user = users.find(user => user.id === userId);
  if (user) {
    return user;
  } else {
    return { firstName: '', lastName: '', username: '' };
  }
};

export const formatCommentDateTime = value => {
  if (!value) {
    return '--';
  }

  return moment(value).format('MMM D [at] h:mm a');
};

export const formatComment = commentText => {
  const fullComment = _clone(commentText);

  if (isMention(fullComment)) {
    const allContent = [];
    const allText = fullComment.split(' ');
    let currentStartPosition = 0;
    //this code is basically tokenizing the comment if it finds a mention in it. It basically splits the string into a array of strings
    allText.forEach((textPiece, index) => {
      if (isMention(textPiece)) {
        const tempString = allText.slice(currentStartPosition, index);
        allContent.push(tempString.join(' ') + ' '); //this is needed to give space between mention
        allContent.push(textPiece);
        allContent.push(' '); //this is needed to give space between mention
        currentStartPosition = index + 1;
      }
    });
    if (currentStartPosition < allText.length) {
      const tempString = allText.slice(currentStartPosition);
      allContent.push(tempString.join(' '));
    }
    return allContent;
  }

  return [fullComment];
};
